import _ from 'lodash'

import axios from 'axios'

import generic from '@/generic'

// Make Axios play nice with Django CSRF
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'


/// ////////////////////////////////////////////////////////////////////

const api = {
    apiClient(options) {
        let base = {
            baseURL: '/api/',
            headers: {
                'Content-Type': 'application/json',
            },
            xhrFields: {
                withCredentials: true,
            },
            data: {},
        };

        if (typeof options === 'object') {
            base = { ...base, ...options };
        }
        const axiosApi = axios.create(base);
        return axiosApi;
    },
};


_.assign(
    api,
    generic,
);

export default api;



// WEBPACK FOOTER //
// ./src/api.js